import type { Variants } from 'framer-motion';

// TODO: Adding an `exit` animation appears to be complicated
// when paired with a `stagger` page load animation...
// We may need to take a different approach to this problem.

export enum ItemVariant {
    Initial = 'initial',
    Show = 'show',
    // Exit = 'exit'
}

export const listVariants: Variants = {
    [ItemVariant.Initial]: {
        transition: {
            staggerChildren: 0.04,
        },
    },
    [ItemVariant.Show]: {
        transition: {
            staggerChildren: 0.04,
            // Derived from the values in:
            // `_profile.scss` > `$yat_profile-page-load-values`
            delayChildren: 1.92,
        },
    },
    /*
    [ItemVariant.Exit]: {
        transition: {
            staggerChildren: 0,
            delayChildren: 0
        }
    }
    */
};

export const itemVariants: Variants = {
    [ItemVariant.Initial]: {
        opacity: 0,
        translateY: '100%',
    },
    [ItemVariant.Show]: {
        opacity: 1,
        translateY: 0,
    },
    /*
    [ItemVariant.Exit]: {
        opacity: 0,
        translateY: '-100%'
    }
    */
};
